export const maxMessageLength = 5000
